export const GET_LEAD_LABELS_PATH = 'api/landlord/leads/labels';
